import { ArticleCard, ArticleCardProps } from 'component/DefaultCard';
import { useTranslation } from 'react-i18next';

export const WorkaroundView = ({
  articleList,
  isLoading,
}: Pick<ArticleCardProps, 'articleList' | 'isLoading'>) => {
  const { t } = useTranslation('vulnerability');

  return (
    <ArticleCard
      header={t('workarounds.Workarounds')}
      articleList={articleList}
      id='workarounds'
      isLoading={isLoading}
    />
  );
};
